export const AB_TESTS_TYPE_MAIN = 'MAIN' as const
